var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("h4", [_vm._v("Título")]),
          _vm._v(" "),
          _vm.project.projectType == "event"
            ? _c("span", [_vm._v("Qual o nome do seu evento?")])
            : _c("span", [_vm._v("Qual o nome do seu projeto?")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.title,
                  expression: "title"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", maxlength: "40" },
              domProps: { value: _vm.title },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.title = $event.target.value
                  },
                  function($event) {
                    return _vm.editSlug()
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Até 40 caracteres")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.slug,
                  expression: "slug"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", maxlength: "40", readonly: "" },
              domProps: { value: _vm.slug },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.slug = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.project.projectType != "event"
        ? _c("div", { staticClass: "row" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _c(
                  "b-form-radio-group",
                  {
                    attrs: { id: "radios2", name: "radioSubComponent2" },
                    model: {
                      value: _vm.donationType,
                      callback: function($$v) {
                        _vm.donationType = $$v
                      },
                      expression: "donationType"
                    }
                  },
                  [
                    _c("b-form-radio", { attrs: { value: "single" } }, [
                      _vm._v("Pontual")
                    ]),
                    _vm._v(" "),
                    _c("b-form-radio", { attrs: { value: "monthly" } }, [
                      _vm._v("Contínua")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.donationType == "single"
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "money",
                            rawName: "v-money",
                            value: _vm.money,
                            expression: "money"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.donationTotal,
                            expression: "donationTotal"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.donationTotal },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.donationTotal = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Quanto você precisa arrecadar?")])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("h4", [_vm._v("Valor Mínimo")]),
          _vm._v(" "),
          _vm.project.projectType == "event"
            ? _c("span", [
                _vm._v(
                  "Defina o valor mínimo de doação para seu evento. (Valores à partir de R$ 20)"
                )
              ])
            : _c("span", [
                _vm._v(
                  "Defina o valor mínimo de doação para seu projeto. (Valores à partir de R$ 20)"
                )
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "money",
                  rawName: "v-money",
                  value: _vm.money,
                  expression: "money"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.minimumValue,
                  expression: "minimumValue"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.minimumValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.minimumValue = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8 row" }, [
          _c("div", { staticClass: "form-group col-md" }, [
            _c("input", {
              directives: [
                {
                  name: "money",
                  rawName: "v-money",
                  value: _vm.money,
                  expression: "money"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.optionalValue1,
                  expression: "optionalValue1"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.optionalValue1 },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.optionalValue1 = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md" }, [
            _c("input", {
              directives: [
                {
                  name: "money",
                  rawName: "v-money",
                  value: _vm.money,
                  expression: "money"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.optionalValue2,
                  expression: "optionalValue2"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.optionalValue2 },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.optionalValue2 = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md" }, [
            _c("input", {
              directives: [
                {
                  name: "money",
                  rawName: "v-money",
                  value: _vm.money,
                  expression: "money"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.optionalValue3,
                  expression: "optionalValue3"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.optionalValue3 },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.optionalValue3 = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md" }, [
            _c("input", {
              directives: [
                {
                  name: "money",
                  rawName: "v-money",
                  value: _vm.money,
                  expression: "money"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.optionalValue4,
                  expression: "optionalValue4"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.optionalValue4 },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.optionalValue4 = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "photo-container row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("img", {
                attrs: { src: _vm.logo },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.selectLogo()
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                ref: "uploadBtnLogo",
                staticClass: "input-photo",
                attrs: { type: "file" },
                on: { change: _vm.uploadLogo }
              })
            ]),
            _vm._v(" "),
            !_vm.isUploadingLogo
              ? _c("div", { staticClass: "col-md-6" }, [
                  _c("span", [
                    _vm._v(
                      "Clique na imagem ao lado para adicionar uma nova foto."
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Tamanho recomendado 500x500. Max 2,5MB")])
                ])
              : _c("div", { staticClass: "col-md-6" }, [
                  _c("span", [_vm._v("Aguarde...")])
                ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("h4", [_vm._v("Foto de Capa")]),
          _vm._v(" "),
          _vm.project.projectType == "event"
            ? _c("span", [
                _vm._v("Adicione uma imagem que represente o seu evento.")
              ])
            : _c("span", [
                _vm._v(
                  "Adicione uma imagem que represente sua Organização Social."
                )
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "photo-container row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("img", {
                attrs: { src: _vm.picture },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.selectPhoto()
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                ref: "uploadBtn",
                staticClass: "input-photo",
                attrs: { type: "file" },
                on: { change: _vm.uploadPhoto }
              })
            ]),
            _vm._v(" "),
            !_vm.isUploadingPicture
              ? _c("div", { staticClass: "col-md-6" }, [
                  _c("span", [
                    _vm._v(
                      "Clique na imagem ao lado para adicionar uma nova foto."
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Tamanho recomendado 800x600. Max 2,5MB")])
                ])
              : _c("div", { staticClass: "col-md-6" }, [
                  _c("span", [_vm._v("Aguarde...")])
                ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _vm.showVideo
            ? _c("div", { staticClass: "embed-container" }, [
                _c("iframe", {
                  attrs: {
                    src: _vm.video,
                    frameborder: "0",
                    allowfullscreen: ""
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.video,
                  expression: "video"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.video },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.video = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Somente Youtube.")])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.project.projectType != "event"
        ? _c("div", { staticClass: "row" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _vm.categoriesLimit
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert alert-danger alert-dismissible fade show",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n        Você já atingiu o limite de categorias.\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-form-checkbox-group",
                  {
                    attrs: { id: "checkboxes2", name: "flavour2" },
                    model: {
                      value: _vm.categories,
                      callback: function($$v) {
                        _vm.categories = $$v
                      },
                      expression: "categories"
                    }
                  },
                  _vm._l(_vm.categoriesList, function(c) {
                    return _c(
                      "b-form-checkbox",
                      {
                        key: c.CategoryId,
                        staticClass: "col-md-3",
                        attrs: { value: c.CategoryId }
                      },
                      [_vm._v(_vm._s(c.name))]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.project.projectType != "event"
        ? _c("div", { staticClass: "row" }, [
            _vm._m(6),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _c(
                  "b-form-checkbox-group",
                  {
                    attrs: { id: "checkboxes2", name: "flavour2" },
                    model: {
                      value: _vm.ods,
                      callback: function($$v) {
                        _vm.ods = $$v
                      },
                      expression: "ods"
                    }
                  },
                  _vm._l(_vm.odsList, function(o) {
                    return _c(
                      "b-form-checkbox",
                      {
                        key: o.number,
                        staticClass: "col-md-3",
                        attrs: { value: o.slug }
                      },
                      [_vm._v(_vm._s(o.title))]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("h4", [_vm._v("Localização")]),
          _vm._v(" "),
          _vm.project.projectType == "event"
            ? _c("span", [_vm._v("Onde será o evento?")])
            : _c("span", [_vm._v("Em qual cidade seu projeto se encontra?")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.city,
                  expression: "city"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder:
                  _vm.project.projectType == "event"
                    ? "Local do evento"
                    : "Nome da cidade"
              },
              domProps: { value: _vm.city },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.city = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.project.projectType != "event"
        ? _c("div", { staticClass: "row" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shortDescription,
                      expression: "shortDescription"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", maxlength: "100" },
                  domProps: { value: _vm.shortDescription },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.shortDescription = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Até 100 caracteres.")])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _vm.project & (_vm.project.projectType == "event")
            ? _c("h4", [_vm._v("Descrição do Evento")])
            : _c("h4", [_vm._v("Descrição")]),
          _vm._v(" "),
          _vm.project & (_vm.project.projectType == "event")
            ? _c("span", [
                _vm._v(
                  "Descreva o evento e conte para os convidados sobre o propósito e projeto social que toca o seu coração."
                )
              ])
            : _c("span", [
                _vm._v(
                  "Descreva seu projeto. Conte por quê você precisa de doações e qual o propósito delas."
                )
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("vue-editor", {
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.site,
                  expression: "site"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.site },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.site = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.project.projectType != "event"
        ? _c("div", { staticClass: "row" }, [
            _vm._m(9),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _c(
                  "b-form-group",
                  [
                    _c(
                      "b-form-checkbox-group",
                      {
                        attrs: {
                          id: "checkbox-group-2",
                          name: "habilities",
                          stacked: ""
                        },
                        model: {
                          value: _vm.selectedHabilities,
                          callback: function($$v) {
                            _vm.selectedHabilities = $$v
                          },
                          expression: "selectedHabilities"
                        }
                      },
                      _vm._l(_vm.arrHabilitiesWithMessages, function(c, k) {
                        return _c(
                          "b-form-checkbox",
                          { key: k, attrs: { size: "lg", value: c.hability } },
                          [_vm._v(_vm._s(c.message))]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(10),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c(
              "b-form-radio-group",
              {
                attrs: { id: "radios4", name: "radioSubComponent" },
                model: {
                  value: _vm.visibility,
                  callback: function($$v) {
                    _vm.visibility = $$v
                  },
                  expression: "visibility"
                }
              },
              [
                _vm.project.projectType != "event"
                  ? _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("b-form-radio", { attrs: { value: "public" } }, [
                          _vm._v("Público")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.project.projectType != "event"
                  ? _c("div", { staticClass: "col-md-8" }, [
                      _c("span", [
                        _vm._v(
                          "Projetos públicos aparecem na busca do site e Google"
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("b-form-radio", { attrs: { value: "private" } }, [
                      _vm._v("Privado")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" }, [
                  _c("span", [
                    _vm._v(
                      "Projetos privados só são visíveis através deste endereço: "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href: "https://click2giv.com/" + _vm.project.slug
                        }
                      },
                      [
                        _vm._v(
                          "https://click2giv.com/project/" +
                            _vm._s(_vm.project.slug)
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("b-form-radio", { attrs: { value: "inactive" } }, [
                      _vm._v("Inativo")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" }, [
                  _c("span", [_vm._v("Projetos inativos não são exibidos")])
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.project.projectStatus == "disabled"
        ? _c("div", { staticClass: "row" }, [
            _vm._m(11),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              !_vm.project.projectUnallowed
                ? _c("div", [
                    _vm.validated
                      ? _c("h4", [_vm._v("Projeto aguardando avaliação")])
                      : _c("h4", [_vm._v("Projeto com informações pendentes")]),
                    _vm._v(" "),
                    _vm.validated
                      ? _c("span", [
                          _vm._v(
                            "Parabéns! Seu projeto está completo, e será analisado para liberação dentro do prazo de 24 horas por nossa equipe de curadoria."
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "Preencha todos os campos obrigatórios e aguarde a avaliação da nossa equipe de curadoria."
                          )
                        ])
                  ])
                : _c("div", [
                    _c("h4", [_vm._v("Projeto Rejeitado")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Seu projeto foi rejeitado! Motivo: " +
                          _vm._s(_vm.project.projectUnallowedMessage)
                      )
                    ])
                  ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row", attrs: { id: "saveBar" } }, [
        _c("div", { staticClass: "col-md-6" }, [
          _vm.showMsg
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.msg) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSuccessMsg
            ? _c(
                "div",
                {
                  staticClass:
                    "alert alert-success alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.successMsg) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.save()
                }
              }
            },
            [_vm._v("Salvar Projeto")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.project.projectType != "event"
        ? _c(
            "b-modal",
            {
              attrs: { size: "lg", title: "Selecione sua Habilidade" },
              model: {
                value: _vm.showHabilityModal,
                callback: function($$v) {
                  _vm.showHabilityModal = $$v
                },
                expression: "showHabilityModal"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "\n      A Click2giv é uma plataforma que tem por objetivo aproximar pessoas, conectar aqueles que desejam contribuir, com aqueles que necessitam de contribuição. "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n      Agora sua Organização Social pode contar com uma rede de apoio de voluntários e pessoas que estão dispostas a ajudar com aquilo que sabem. "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n      Escolha na lista abaixo aquilo que sua ONG necessita para que possamos conectar com aqueles que possuem estas habilidades:\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-form-checkbox-group",
                    {
                      attrs: {
                        id: "checkbox-group-6",
                        name: "modal-habilities",
                        stacked: ""
                      },
                      model: {
                        value: _vm.selectedHabilities,
                        callback: function($$v) {
                          _vm.selectedHabilities = $$v
                        },
                        expression: "selectedHabilities"
                      }
                    },
                    _vm._l(_vm.arrHabilitiesWithMessages, function(c, k) {
                      return _c(
                        "b-form-checkbox",
                        { key: k, attrs: { size: "lg", value: c.hability } },
                        [_vm._v(_vm._s(c.message))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Endereço da URL")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          'Este é o endereço de seu projeto. Importante: ao modificar o "título" de seu projeto este endereço mudará automaticamente.'
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Arrecadação")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Defina a meta de arrecadação da Organização Social.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Opções de Valores")]),
      _vm._v(" "),
      _c("span", [_vm._v("Defina as opções de valores de doação")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Logo")]),
      _vm._v(" "),
      _c("span", [_vm._v("Adicione a logo da sua Organização Social.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Vídeo")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Opcional. Adicione um vídeo para atrair mais doadores.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Categorias")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Escolha até duas categorias para os doadores encontrarem seu projeto mais facilmente."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Agenda 2030 ONU")]),
      _vm._v(" "),
      _c("span", [_vm._v("Escolha as ODS que representam o seu projeto.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Descrição curta")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n        Descreva seu projeto em poucas palavras.\n        Essa descrição ficará na miniatura do seu projeto em nossa página principal.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Site")]),
      _vm._v(" "),
      _c("span", [_vm._v("Informe o site do seu projeto ou organização.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Habilidades")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Escolha na lista aquilo que sua ONG necessita para que possamos conectar com aqueles que possuem estas habilidades."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Exposição")]),
      _vm._v(" "),
      _c("span", [_vm._v("Como quer aparecer em nosso site?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Status do Projeto")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Acompanhe aqui o status de publicação do seu projeto.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffcffce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffcffce8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage-project/Info.vue
// module id = null
// module chunks = 